import { ReactElement } from "react";
import { Route } from "_/components/router";

import { EmailVerify } from "_/components/email-verify";
import { AccountRecovery } from "_/components/account-recovery";
import { AccountRsvp } from "_/components/account-rsvp";
import { publicUrls } from "_/routes";

import * as S from "./styled";

export const Public = (): ReactElement => {
  return (
    <S.Wrapper>
      <Route path={publicUrls.verify} component={EmailVerify} />
      <Route path={publicUrls.recovery} component={AccountRecovery} />
      <Route path={publicUrls.rsvp} component={AccountRsvp} />
    </S.Wrapper>
  );
};
